import {OVERVIEW_CLEAR_SEARCH} from '~/frontend/src/constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import clearSearchOrig from '~/frontend/src/actions/panel/dataTable/clearSearch';


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {Function}
 */
const clearSearch = ( panelKey : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    dispatch( {
        type: OVERVIEW_CLEAR_SEARCH,
        panelKey
    } );

    dispatch( clearSearchOrig( panelKey ) );
}
export type ClearSearch = typeof clearSearch;

export default clearSearch;
